import UIAlert from 'UIComponents/alert/UIAlert';
import useEnrollmentListSizeExact from 'automation-ui-canvas/components/enrollment/hooks/useEnrollmentListSizeExact';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentListSizeExactAlert = ({
  objectTypeId,
  listId,
  previewLink
}) => {
  const {
    error,
    loading,
    showLongLoadingMessage,
    listSize,
    hasListsToolAccess,
    showAccuracyDisclaimer
  } = useEnrollmentListSizeExact({
    listId,
    objectTypeId
  });
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: error ? 'danger' : showAccuracyDisclaimer ? 'warning' : 'info',
    children: [error ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.hybridCalculation.calculationFailed.exact_cob",
      objectTypeId: objectTypeId
    }) : loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      use: "success",
      "data-test-id": "contact-enroll-existing-count-loading",
      showLabel: true,
      label: showLongLoadingMessage ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        objectTypeId: objectTypeId,
        baseLangKey: "automation-ui-enrollment.hybridCalculation.loadingCalculationLong_cob"
      }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        objectTypeId: objectTypeId,
        baseLangKey: "automation-ui-enrollment.hybridCalculation.loadingCalculation_cob"
      })
    }) : showAccuracyDisclaimer ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: hasListsToolAccess ? 'automation-ui-enrollment.hybridCalculation.inaccurateCalculationWithLists_cob' : 'automation-ui-enrollment.hybridCalculation.inaccurateCalculationWithoutLists_cob',
      objectTypeId: objectTypeId
    }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      objectTypeId: objectTypeId,
      baseLangKey: "automation-ui-enrollment.hybridCalculation.metCriteria_cob",
      isJsx: true,
      elements: {
        Bold: 'b'
      },
      options: {
        count: listSize || 0
      }
    }), previewLink]
  });
};
export default EnrollmentListSizeExactAlert;